export const LocalStorageAuthSession = 'AUTH_SESSION'

export type AuthStatus = 'unknown' | 'authenticated' | 'unauthenticated'

export interface AuthState {
  accessToken: string
  refreshToken: string
  userId: string
  organizationId: string
  membershipId: string
  status: AuthStatus
  lastExplicitLoginAt: number
}
